import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import MobileNavigation from "./MobileNavigation";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <>
      <Helmet>
        <title>Che Comodín | Administradores</title>
        <meta
          name="description"
          content="Aplicación web para gestión de salas de juego Che Comodín. Funcionalidades para habilitar máquinas, registrar movimientos de caja, registrar operaciones por cliente y agregar nuevos clientes al sistema."
        />
        <meta
          name="keywords"
          content="Club Comodin, Gestion de Tragamonedas, APOJA, Conajzar, Che Comodin, Control de Tragamonedas en Paraguay, Cumplimiento Normativo de Apuestas, Monitoreo de Salas de Juegos, Regulación de Juegos de Azar"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Helmet>

      <div className="font-sans antialiased min-h-screen bg-gradient-to-b from-red-950 to-red-900">
        {/* Navbar para desktop */}
        {!isLoginPage && <Navbar />}

        {/* Main Content Container */}
        <div className="flex flex-col min-h-screen">
          <main
            className={`flex-grow w-full ${!isLoginPage ? "pt-16 pb-20" : ""}`}
          >
            {/* Content Wrapper con márgenes responsivos */}
            <div
              className={`
              w-full
              ${!isLoginPage ? "px-2 sm:px-4 md:px-6 lg:px-8" : ""}
              mx-auto
              md:max-w-[90%]
              lg:max-w-[85%]
              xl:max-w-[1000px]
              ${location.pathname === "/caja" ? "md:max-w-[800px]" : ""}
            `}
            >
              {children}
            </div>
          </main>

          {/* Mobile Navigation */}
          {!isLoginPage && (
            <div className="fixed bottom-0 left-0 right-0 z-50">
              <MobileNavigation />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Layout;
